import { render, staticRenderFns } from "./ReleasesComponent.vue?vue&type=template&id=dec60528&scoped=true"
import script from "./ReleasesComponent.vue?vue&type=script&lang=js"
export * from "./ReleasesComponent.vue?vue&type=script&lang=js"
import style0 from "./ReleasesComponent.vue?vue&type=style&index=0&id=dec60528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec60528",
  null
  
)

export default component.exports